"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowSizeManager = exports.setUpWindowSizeListeners = exports.setupBreakpointListeners = exports.clearMediaQueries = void 0;
var React = __importStar(require("react"));
var common_1 = require("../../common");
var models_1 = require("../../models");
/**
 * Static set of media queries to check each Bootstrap breakpoint.
 *
 * @remarks
 * Each WindowSizeManager will only register/unregister listeners as opposed to each maintaining
 * their own array of MediaQueryList
 */
var breakpointMediaQueries;
var clearMediaQueries = function () {
    return (breakpointMediaQueries = undefined);
};
exports.clearMediaQueries = clearMediaQueries;
var setupBreakpointListeners = function (setter) {
    // set up the (static) media queries if not already defined
    breakpointMediaQueries =
        breakpointMediaQueries !== null && breakpointMediaQueries !== void 0 ? breakpointMediaQueries : models_1.breakpointMetadata.map(function (bpmd) {
            var minQuery = bpmd.min_inclusive > 0
                ? "(min-width: " + bpmd.min_inclusive + "px)"
                : undefined;
            var maxQuery = bpmd.max_exclusive < Number.MAX_SAFE_INTEGER
                ? "(max-width: " + (bpmd.max_exclusive - 1) + "px)"
                : undefined;
            var fullQuery = ["screen", minQuery, maxQuery]
                .filter(function (x) { return x; })
                .join(" and ");
            return window.matchMedia(fullQuery);
        });
    // wire up listeners for this WindowSizeManager
    var myListeners = [];
    breakpointMediaQueries.forEach(function (query, index) {
        var listener = function (_a) {
            var matches = _a.matches;
            if (matches) {
                setter(models_1.breakpointMetadata[index].name);
            }
        };
        query.addListener(listener);
        myListeners.push(listener);
        listener(query);
    });
    // return a cleanup function
    return function () {
        myListeners.forEach(function (l, i) {
            breakpointMediaQueries === null || breakpointMediaQueries === void 0 ? void 0 : breakpointMediaQueries[i].removeListener(l);
        });
    };
};
exports.setupBreakpointListeners = setupBreakpointListeners;
var setUpWindowSizeListeners = function (hSetter, wSetter) {
    var listener = function () {
        var _a;
        (_a = document === null || document === void 0 ? void 0 : document.documentElement) === null || _a === void 0 ? void 0 : _a.style.setProperty("--vh", window.innerHeight / 100 + "px");
        hSetter(window.innerHeight);
        wSetter(window.innerWidth);
    };
    window.addEventListener("resize", listener);
    window.addEventListener("load", listener);
    hSetter(window.innerHeight);
    wSetter(window.innerWidth);
    return function () {
        window.removeEventListener("resize", listener);
        window.removeEventListener("load", listener);
    };
};
exports.setUpWindowSizeListeners = setUpWindowSizeListeners;
var WindowSizeManager = function (_a) {
    var children = _a.children;
    var _b = React.useState(), currentBreakpoint = _b[0], setCurrentBreakpoint = _b[1];
    var _c = React.useState(), viewportHeight = _c[0], setViewportHeight = _c[1];
    var _d = React.useState(), viewportWidth = _d[0], setViewportWidth = _d[1];
    React.useEffect(function () { return (0, exports.setupBreakpointListeners)(setCurrentBreakpoint); }, []);
    React.useEffect(function () { return (0, exports.setUpWindowSizeListeners)(setViewportHeight, setViewportWidth); }, []);
    return (React.createElement(common_1.WindowSizeContext.Provider, { value: {
            currentBreakpoint: currentBreakpoint,
            isDesktopSized: currentBreakpoint === models_1.Breakpoint.LG ||
                currentBreakpoint === models_1.Breakpoint.XL,
            isMobileSized: currentBreakpoint === models_1.Breakpoint.XS ||
                currentBreakpoint === models_1.Breakpoint.SM,
            isTabletSized: !(currentBreakpoint === models_1.Breakpoint.LG ||
                currentBreakpoint === models_1.Breakpoint.XL),
            viewportHeight: viewportHeight,
            viewportWidth: viewportWidth,
        } }, children));
};
exports.WindowSizeManager = WindowSizeManager;
exports.default = exports.WindowSizeManager;
